export const BASE_CHANGE_FIELD = 'BASE_CHANGE_FIELD';